import React from "react";
import { useInView } from "react-intersection-observer";
import Reveal from "react-awesome-reveal";
import { useState } from "react";
import "./qualification.css";

const Qualification = () => {
  // const [toggleState, setToggleState] = useState(1);

  // const toggleTab = (index) => {
  //   setToggleState(index);
  // };

  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.75,
  });

  return (
    <div ref={ref}>
      <Reveal effect="fade" when={inView} triggerOnce={true}>
        <section className="qualification section" id="qualifications">
          <h2 className="section__title">Experience</h2>
          <span className="section__subtitle">My personal journey</span>
          <div className="qualification__container container">
            <div className="qualification__tabs">
              <div className="qualification__button qualification__active button--flex">
                <i className="uil uil-briefcase-alt qualification__icon"></i>{" "}
                Experience
              </div>
            </div>

            <div className="qualification__sections">
              <div className="qualification__content qualification__content-active">
                <div className="qualification__data">
                  <div>
                    <h3 className="qualification__title">
                      Software Developer under Professor Wen Fen Yang{" "}
                    </h3>
                    <span className="qualification__subtitle">
                      National Chung Cheng University
                    </span>
                    <div className="qualification__calendar">
                      <i className="uil uil-calendar-alt"></i> 2022 - 2023
                    </div>
                  </div>
                  <div>
                    <span className="qualification__rounder"></span>
                    <span className="qualification__line"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Reveal>
    </div>
  );
};

export default Qualification;
